import script from "./BillingDataPaid.PaymentInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingDataPaid.PaymentInfo.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__